import { useEerieBackdrop } from "@/lib/eerie";
import { MatchKeyLanding } from "@/components/MatchKey/MatchKeyShell";
import { CHECKERS_CFG } from "@/components/MatchKey/cfgs";

export default function CheckersLanding() {
  useEerieBackdrop("estampie"); // medieval estampie (per user iter 41)
  return <MatchKeyLanding cfg={CHECKERS_CFG} />;
}
